// extracted by css-extract-rspack-plugin
export default {"feedbackButton":"feedbackButton-RprR8H"};